import { getErrorMessage } from '../../ReactQuery';

/**
 * How a failed request should be surfaced. A client error (a `Response` with status < 500 — bad credentials, a
 * 403 SSO-required org, an expired pending login, a wrong MFA code) is an expected outcome the user can act on,
 * shown `inline`; anything else (a network failure or a 5xx) is unexpected and belongs in a `toast`.
 */
export type ErrorPresentation = { kind: 'inline' | 'toast'; message: string };

/**
 * Split a react-query request error into how it should be surfaced (see {@link ErrorPresentation}), resolving the
 * displayed copy from the response body with a per-surface fallback. Centralises the `< 500 ? inline : toast`
 * decision the login steps share so the classification can't drift between them.
 */
export function presentRequestError(
  error: unknown,
  { inlineFallback, toastFallback }: { inlineFallback: string; toastFallback: string },
): ErrorPresentation {
  if (error instanceof Response && error.status < 500) {
    return { kind: 'inline', message: getErrorMessage(error, inlineFallback) };
  }
  return { kind: 'toast', message: getErrorMessage(error, toastFallback) };
}
